(() => {
  'use strict';

  const isElement = value => value instanceof Element;

  const readThemeData = () => {
    const node = document.getElementById('MixedownThemeData');
    if (!node) return { productVariants: [] };

    try {
      const data = JSON.parse(node.textContent);
      return { productVariants: Array.isArray(data.productVariants) ? data.productVariants : [] };
    } catch (error) {
      return { productVariants: [] };
    }
  };

  const initProduct = () => {
    const gallery = document.getElementById('gallery');
    if (!gallery) return;
    if (gallery.dataset.productInitialized === 'true') return;
    gallery.dataset.productInitialized = 'true';

    const items = Array.from(gallery.querySelectorAll('.product__item-img, .product__item-video'));
    const prevArrow = document.getElementById('prev-arrow');
    const nextArrow = document.getElementById('next-arrow');
    const navDotsContainer = document.getElementById('nav-dots');
    const productVariants = readThemeData().productVariants;
    const desktopMedia = window.matchMedia('(min-width: 749px)');
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const arrowLeftUrl = gallery.dataset.arrowLeft || '';
    const arrowRightUrl = gallery.dataset.arrowRight || '';

    let currentIndex = 0;
    let lastTouchTime = 0;
    let touchStarted = false;
    let touchStartX = 0;
    let touchEndX = 0;

    const isDesktop = () => desktopMedia.matches;

    const addFadeAnimation = item => {
      item.classList.add('fade-in');
      window.setTimeout(() => item.classList.remove('fade-in'), 300);
    };

    const handleVideo = (item, shouldPlay) => {
      if (item.tagName !== 'VIDEO') return;
      if (shouldPlay) {
        item.play().catch(() => {});
      } else {
        item.pause();
        item.currentTime = 0;
      }
    };

    const updateDots = () => {
      if (!navDotsContainer) return;
      navDotsContainer.querySelectorAll('.nav-dot').forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    };

    const updateMediaPosition = (animate = true) => {
      if (items.length === 0) return;


      if (items.length === 1) {
        items[0].classList.add('active');
        if (animate && !isTouch) addFadeAnimation(items[0]);
        handleVideo(items[0], true);
        return;
      }

      if (isDesktop()) {
        items.forEach((item, index) => {
          const isActive = index === currentIndex;
          item.style.transform = '';
          item.style.transition = '';
          item.classList.toggle('active', isActive);
          if (isActive) {
            if (item.tagName === 'IMG') item.fetchPriority = 'high';
            if (animate) addFadeAnimation(item);
            handleVideo(item, true);
          } else {
            if (item.tagName === 'IMG') item.fetchPriority = 'low';
            handleVideo(item, false);
          }
        });
      } else {
        const offset = currentIndex * -100;
        items.forEach((item, index) => {
          item.style.transform = `translateX(${offset}%)`;
          item.style.transition = 'transform 0.3s ease-out';
          handleVideo(item, index === currentIndex);
        });
        if (!isTouch && animate) addFadeAnimation(items[currentIndex]);
      }

      updateDots();
    };

    const createDots = () => {
      if (!navDotsContainer || items.length <= 1) return;
      navDotsContainer.replaceChildren();
      items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = index === currentIndex ? 'nav-dot active' : 'nav-dot';
        dot.setAttribute('aria-label', String(index + 1));
        dot.addEventListener('click', () => {
          currentIndex = index;
          updateMediaPosition();
        });
        navDotsContainer.appendChild(dot);
      });
    };

    const navigateMedia = direction => {
      if (items.length <= 1) return;
      currentIndex = direction === 'left'
        ? (currentIndex - 1 + items.length) % items.length
        : (currentIndex + 1) % items.length;
      updateMediaPosition();
    };

    const scrollToVariantMedia = selectedVariant => {
      const variantMedia = selectedVariant && (selectedVariant.featured_media || selectedVariant.featured_image);
      if (!variantMedia) return;

      const variantMediaIndex = items.findIndex(item =>
        item.tagName === 'IMG' && item.id === `ProductImage-${variantMedia.id}`
      );

      if (variantMediaIndex !== -1 && variantMediaIndex !== currentIndex) {
        currentIndex = variantMediaIndex;
        updateMediaPosition();
      }
    };

    const updateCursor = event => {
      if (!arrowLeftUrl || !arrowRightUrl) return;
      const rect = gallery.getBoundingClientRect();
      const isLeft = event.clientX - rect.left < rect.width / 2;
      gallery.style.cursor = `url('${isLeft ? arrowLeftUrl : arrowRightUrl}') 16 14, ${isLeft ? 'w-resize' : 'e-resize'}`;
    };

    const setProductInfoHeight = () => {
      const productInfo = document.querySelector('.product-info');
      if (!productInfo) return;

      if (isDesktop()) {
        const header = document.getElementById('shopify-section-header');
        if (header) productInfo.style.height = `calc(95vh - ${header.offsetHeight}px)`;
      } else {
        productInfo.style.height = '';
      }
    };

    if (items.length > 1) {
      if (prevArrow) {
        prevArrow.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          navigateMedia('left');
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          navigateMedia('right');
        });
      }

      gallery.addEventListener('click', event => {
        if (Date.now() - lastTouchTime > 800 && !(isElement(event.target) && event.target.closest('video'))) {
          const x = event.clientX - gallery.getBoundingClientRect().left;
          navigateMedia(x < gallery.offsetWidth / 2 ? 'left' : 'right');
        }
      });

      if (isTouch) {
        let isScrolling = false;
        let touchStartY = 0;

        gallery.addEventListener('touchstart', event => {
          touchStarted = true;
          lastTouchTime = Date.now();
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchEndX = touchStartX;
          isScrolling = false;
        }, { passive: true });

        gallery.addEventListener('touchmove', event => {
          if (!touchStarted) return;

          touchEndX = event.touches[0].clientX;
          const touchEndY = event.touches[0].clientY;
          const horizontalDiff = Math.abs(touchEndX - touchStartX);
          const verticalDiff = Math.abs(touchEndY - touchStartY);

          if (horizontalDiff > 10 || verticalDiff > 10) {
            if (horizontalDiff > verticalDiff * 1.2 && horizontalDiff > 20) {
              event.preventDefault();
              isScrolling = false;
            } else {
              isScrolling = true;
            }
          }
        }, { passive: false });

        gallery.addEventListener('touchend', () => {
          if (touchStarted && !isScrolling) {
            const diff = touchEndX - touchStartX;
            if (Math.abs(diff) > 50) navigateMedia(diff < 0 ? 'right' : 'left');
          }
          touchStarted = false;
          isScrolling = false;
        }, { passive: true });
      }

      gallery.addEventListener('mousemove', updateCursor);

      createDots();
    }

    const getSelectedVariantFromOptionClick = button => {
      const selectedOptions = {};
      document.querySelectorAll('.option-value').forEach(optionButton => {
        const optionKey = `option${optionButton.dataset.option}`;
        if (optionButton === button || optionButton.classList.contains('active')) selectedOptions[optionKey] = optionButton.dataset.value;
      });
      selectedOptions[`option${button.dataset.option}`] = button.dataset.value;
      return productVariants.find(variant =>
        Object.entries(selectedOptions).every(([key, value]) => variant[key] === value)
      );
    };

    document.addEventListener('click', event => {
      if (!isElement(event.target)) return;
      const button = event.target.closest('.option-value');
      if (!button || button.classList.contains('disabled')) return;
      const selectedVariant = getSelectedVariantFromOptionClick(button);
      if (selectedVariant) scrollToVariantMedia(selectedVariant);
    });

    document.querySelectorAll('.product-info__description-pc table, .product-info__description-mobile table').forEach(table => {
      if (table.parentElement && table.parentElement.classList.contains('product-table')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'product-table';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    let resizeFrame = null;
    const handleResize = () => {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = null;
        setProductInfoHeight();
        updateMediaPosition(false);
      });
    };

    if (items.length > 0) updateMediaPosition();
    setProductInfoHeight();
    window.addEventListener('resize', handleResize, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProduct, { once: true });
  } else {
    initProduct();
  }
})();
